module.exports = __webpack_public_path__ + "static/media/hausketch-icon.cb6046f1.svg";